import React from "react";
import { FormatMessage } from "react-globalize";

export default function SectionDoNotSellMyPersonalInformation(props)
{
    return (<section id="section13" className="content-section text-center about-section sectionPage">
      <div className="row">
        <div className="col-lg-8 col-lg-offset-2 col-sm-10 col-sm-offset-1">
          <div className="title-v1">
            <div className="col-sm-12 col-xs-12">
              <h1 className="text-center"><FormatMessage locale={props.locale}
                  path="doNotSellMyPersonalInformationPage/title" />
              </h1>
              <hr className="small"/>
            </div>
          </div>
        </div>
      </div>
      <div className="row text-left">
        <div className="col-sm-10 col-xs-10 col-xs-offset-1">
          <p className="text-left">
            <FormatMessage locale={props.locale} elements={{phone: <a style={{fontWeight: "normal"}} href="tel:-18009262277"></a> }} path="doNotSellMyPersonalInformationPage/information1"/>
          </p>
        </div>
        <div className="col-sm-10 col-xs-10 col-xs-offset-1">
          <p className="text-left">
            <FormatMessage locale={props.locale} path="doNotSellMyPersonalInformationPage/information2"/>
          </p>
        </div>
        <div className="col-sm-10 col-xs-10 col-xs-offset-1">
          <p style={{fontWeight:"bold"}}>
          <FormatMessage locale={props.locale} path="doNotSellMyPersonalInformationPage/subTitle"/>
          </p>
          <ol>
            <li style={{marginTop: 10, marginBottom: 10}}>
              <div style={{marginLeft:10, textIndent: -9}}>
                - <FormatMessage locale={props.locale} elements={{brk: <p style={{padding:0 , margin: 0}}></p>, email: <a className="strong" href="mailto:optout@barri.com"></a>}} path="doNotSellMyPersonalInformationPage/option1" />
              </div>
            </li>
            <li style={{marginTop: 10, marginBottom: 10}}>
              <div style={{marginLeft:10, textIndent: -9}}>
                - <FormatMessage locale={props.locale} elements={{phone: <a className="strong" href="tel:-18009262277"></a> }} path="doNotSellMyPersonalInformationPage/option2"/>
              </div>
            </li>
          </ol>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 center-block" style={{marginTop: 20}}>
          <p>
            <div className="col-xs-12">
              <a target="_blank" href="/documents/Do_not_sell_my_personal_information_2023.pdf">
                <button type="button" className="btn btn-primary" href="/documents/Do_not_sell_my_personal_information_2023.pdf">
                  <FormatMessage locale={props.locale} path="doNotSellMyPersonalInformationPage/btnFormDownload" />
                </button>
              </a>
            </div>
          </p>
        </div>
      </div>
  </section>);
  }



// WEBPACK FOOTER //
// ./js/SectionDoNotSellMyPersonalInformation.js